import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import './App.css';
import './bootstrap/bootstrap-5.3.3-dist/css/bootstrap.min.css';
import HeaderLogin from './personalPage/courseHeaderLogin';
import CoursePage from './personalPage/courses';
import PersonalPage from './personalPage/personalPage';

 

function HeaderComponent() {
    const location = useLocation();

    const shouldDisplayHeader = () => {
        return !(location.pathname === '/' || location.pathname === '/login' || location.pathname === '/signup');
    };

    return shouldDisplayHeader() ? <HeaderLogin /> : null;
}

// function AudioVideoControls() {
   
//     // useEffect(() => {
//     //     const elements = [
//     //         { selector: '#myExperienceImg', animationClass: 'animate-slideRight' },
//     //         { selector: '#myExperienceText', animationClass: 'animate-slideLeft' },
//     //         { selector: '#myExperience', animationClass: 'animate-scaleUp' },
//     //         { selector: '#myEducationImg', animationClass: 'animate-slideTop' },
//     //         { selector: '#myEducationText', animationClass: 'animate-slideBottom' },
//     //         { selector: '#myEducation', animationClass: 'animate-scaleDown' },
//     //         { selector: '#serviceCard1', animationClass: 'animate-slideBottom' },
//     //         { selector: '#serviceCard2', animationClass: 'animate-slideLeft' },
//     //         { selector: '#serviceCard3', animationClass: 'animate-slideRight' },
//     //         { selector: '#serviceCard4', animationClass: 'animate-slideTop' },
//     //         { selector: '#contactUs', animationClass: 'animate-slideRight' },
//     //         { selector: '#footer', animationClass: 'animate-slideLeft' },
//     //         { selector: '#two', animationClass: 'sectionTwoAnimation' },
//     //         { selector: '#about', animationClass: 'animate-slideRight' },
//     //         { selector: '#portfolio', animationClass: 'animate-slideLeft' },
//     //         { selector: '#offers', animationClass: 'animate-scaleUp' },
//     //         { selector: '#awards', animationClass: 'animate-scaleDown' },
//     //         { selector: '#funFacts', animationClass: 'animate-scaleUp' },
//     //     ];

//     //     const applyAnimation = (entries, observer) => {
//     //         entries.forEach(entry => {
//     //             if (entry.isIntersecting) {
//     //                 entry.target.classList.add(entry.target.dataset.animationClass);
//     //                 observer.unobserve(entry.target);
//     //             }
//     //         });
//     //     };

//     //     const observer = new IntersectionObserver(applyAnimation, { threshold: 0.1 });

//     //     elements.forEach(item => {
//     //         const element = document.querySelector(item.selector);
//     //         if (element) {
//     //             element.dataset.animationClass = item.animationClass;
//     //             observer.observe(element);
//     //         }
//     //     });

//     //     return () => {
//     //         observer.disconnect();
//     //     };
//     // }, []);

//     document.addEventListener('error', () => {
//        alert('An error occurred while doing this action. Please try again')
//        window.location.reload()
//     })
//     useEffect(() => {
//         // Check if the prompt has already been shown in this session
//         if (!sessionStorage.getItem('languagePromptShown')) {
//             setTimeout(() => {
//                 const userChoice = window.confirm("Would you like to switch the language to Arabic?");
//                 if (userChoice) {
//                     i18n.changeLanguage('ar');
//                 } else {
//                     i18n.changeLanguage('en');
//                 }
//                 // Mark the prompt as shown
//                 sessionStorage.setItem('languagePromptShown', 'true');
//             }, 1000); // Adding a delay of 1 second for a more natural feel
            
//         }
//     }, []);
// }

function App() {
    return (
        <Router>
            <HeaderComponent />
            <Routes>
                 <Route path="/" element={<PersonalPage />} />
                 <Route path="/courses" element={<CoursePage />} /> 

                {/* Secured adminPanel routes */}                
             
            </Routes>
        </Router>
    );
}

export default App;
